import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Screen from './Screen';
import './Signup.css';
import barterfiLogo from './assets/barterfi-logo.png';
import backIcon from './assets/backspace-icon.png';
import api from './api';


const Signup = ({ onSignup }) => {
  const navigate = useNavigate();


  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    username: '',
    email: '',
    password: ''
  });


const [errorMessage, setErrorMessage] = useState('');
const [showError, setShowError] = useState(false);

const triggerError = (msg) => {
  setErrorMessage(msg);
  setShowError(true);
  setTimeout(() => setShowError(false), 3500); // auto-hide after 3.5s
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validateUsername = (username) => /^[a-z0-9_]+$/.test(username);

  // Emoji checker (wide coverage of Unicode emoji ranges)
  const containsEmoji = (str) => {
    const emojiRegex = /[\p{Emoji_Presentation}\uFE0F]/gu;
    return emojiRegex.test(str);
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const rawName = formData.name.trim();
  const rawSurname = formData.surname.trim();
  const rawUsername = formData.username.trim().toLowerCase();
  const email = formData.email.trim();
  const password = formData.password;

  // ✅ Emoji check
  if (
    containsEmoji(rawName) ||
    containsEmoji(rawSurname) ||
    containsEmoji(rawUsername) ||
    containsEmoji(email)
  ) {
    triggerError('🚫 Emojis are not allowed in name, surname, username, or email.');
    return;
  }

  // ✅ Other validation
  if (!rawName || !rawSurname) {
    triggerError('⚠️ Please enter your full name.');
    return;
  }

  if (!validateUsername(rawUsername)) {
    triggerError('⚠️ Username can only contain lowercase letters, numbers, and underscores.');
    return;
  }

  if (rawUsername.length < 3) {
    triggerError('⚠️ Username must be at least 3 characters long.');
    return;
  }

  if (!validateEmail(email)) {
    triggerError('⚠️ Please enter a valid email address.');
    return;
  }

  if (password.length < 6) {
    triggerError('⚠️ Password must be at least 6 characters.');
    return;
  }

  const newUser = {
    name: `${rawName} ${rawSurname}`,
    username: rawUsername,
    email,
    password,
    profilePic: require('./assets/placeholder-profile.png')
  };

  console.log('📦 Submitting new user:', newUser);

  try {
    const res = await api.post('/auth/signup', newUser);
    console.log('✅ Signed up user:', res.data.user);
    onSignup(res.data.user);
    navigate('/home');
  } catch (err) {
    console.error('❌ Signup failed:', err);
    triggerError(err.response?.data?.message || 'Signup failed. Please try again.');
  }
};


  return (

    <Screen>


{showError && (
  <div className="error-banner">
    {errorMessage}
  </div>
)}

      <div className="signup-screen">
        <div className="signup-topbar">
          <img
            src={backIcon}
            alt="Back"
            className="signup-back-icon"
            onClick={() => navigate('/')}
          />
          <h2 className="signup-topbar-title">Create Account</h2>
        </div>

        <div className="signup-scroll-area">
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="First Name" onChange={handleChange} required />
            <input type="text" name="surname" placeholder="Last Name" onChange={handleChange} required />
            <input type="text" name="username" placeholder="Username (lowercase, _ allowed)" onChange={handleChange} required />
            <input type="email" name="email" placeholder="Email Address" onChange={handleChange} required />
            <input type="password" name="password" placeholder="Password (min 6 chars)" onChange={handleChange} required />

            <div className="signup-info-row">
              <img src={require('./assets/info-icon.png')} alt="Info" className="signup-info-icon" />
              <p className="signup-info-text">
                Manual signups (not using Pi login) can’t access Marketplace features like becoming a merchant, listing products, buying, or earning Pi rewards.
              </p>
            </div>

            <button type="submit" className="signup-btn">Sign Up</button>
          </form>

          <div className="auth-footer">
            Already have an account? <a href="/">Log in</a>
          </div>
        </div>


      </div>
    </Screen>
  );
};

export default Signup;
